import { render, staticRenderFns } from "./scrollingBox.vue?vue&type=template&id=20677e8a&scoped=true&"
import script from "./scrollingBox.vue?vue&type=script&lang=js&"
export * from "./scrollingBox.vue?vue&type=script&lang=js&"
import style0 from "./scrollingBox.vue?vue&type=style&index=0&id=20677e8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20677e8a",
  null
  
)

export default component.exports